/*
 * Shelf: one row of things that runs off the right edge of the screen (.tcs-shelf in tcs-sections.css).
 *
 * The row scrolls natively: swipe, trackpad, shift-wheel, or tabbing through it. The arrows step by the
 * items that fit on screen, less one, so the last one stays in view as a landmark, and each hides at
 * its end. The progress line under the row shows how much there is and where you are in it.
 *
 * Markup: a root with data-shelf, holding [data-shelf-track], [data-shelf-prev] and [data-shelf-next].
 * The root gets .is-scrollable once the row overflows, and --shelf-progress and --shelf-visible for the
 * progress line.
 */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function init(root) {
    if (root.dataset.shelfReady) return;
    const track = root.querySelector('[data-shelf-track]');
    const prev = root.querySelector('[data-shelf-prev]');
    const next = root.querySelector('[data-shelf-next]');
    if (!track || !prev || !next) return;
    root.dataset.shelfReady = '1';
    let frame = 0;

    const update = () => {
      frame = 0;
      const max = track.scrollWidth - track.clientWidth;
      const at = Math.min(Math.max(track.scrollLeft, 0), max);
      root.classList.toggle('is-scrollable', max > 1);
      prev.disabled = at <= 1;
      next.disabled = at >= max - 1;
      root.style.setProperty('--shelf-progress', max > 0 ? (at / max).toFixed(4) : 0);
      root.style.setProperty('--shelf-visible', (track.clientWidth / track.scrollWidth).toFixed(4));
    };
    const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };

    const step = (dir) => {
      const items = track.children;
      if (items.length < 2) return;
      const pitch = items[1].offsetLeft - items[0].offsetLeft;
      const fit = Math.max(1, Math.floor(track.clientWidth / pitch) - 1);
      track.scrollBy({ left: dir * fit * pitch, behavior: reduce.matches ? 'auto' : 'smooth' });
    };

    prev.addEventListener('click', () => step(-1));
    next.addEventListener('click', () => step(1));
    track.addEventListener('scroll', schedule, { passive: true });
    new ResizeObserver(schedule).observe(track);
    update();
  }

  const start = () => document.querySelectorAll('[data-shelf]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', (e) => e.target.querySelectorAll('[data-shelf]').forEach(init));
})();
